import { render, staticRenderFns } from "./ProjectTipsPhotoComponent.vue?vue&type=template&id=7b63b7f5"
import script from "./ProjectTipsPhotoComponent.vue?vue&type=script&lang=js"
export * from "./ProjectTipsPhotoComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectTipsPhotoComponent.vue?vue&type=style&index=0&id=7b63b7f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports